import React, { useState, useEffect, useRef } from "react"
import Select from "react-select"
import {
  Row,
  Col,
  Input,
  Label,
  Button,
  Table,
  UncontrolledTooltip,
} from "reactstrap"
import { withRouter, useParams, useHistory } from "react-router-dom"
import PropTypes from "prop-types"
import Modal from "react-bootstrap/Modal"
//import { connect, useSelector, useDispatch } from "react-redux"
import { connect, useSelector } from "react-redux"
import { get, isEmpty } from "lodash"
import { toast } from "react-toastify"
// import * as branchAction from "../../store/fc2400f3/actions"
import * as followupAction from "../../store/Zm9sbG93dXA/actions"
import * as salesAction from "../../store/c2FsZXMgZW5/actions"
import SimpleReactValidator from "simple-react-validator"
import { clientDetails } from "../../constants/page"
import moment from "moment"
import loadertable from "../../assets/images/loader-table.gif"
import imageNotFound from "../../assets/images/imageNotFound.png"
import clientAction from "../../store/Y2xpZW50/actions"
//Import images
import attachmentDesktop from "../../assets/images/leads/attachmentDesktop.png"
import attachmentMobile from "../../assets/images/leads/attachmentMobile.png"
import api from "../../helpers/Api"
import * as quotationAction from "../../store/cXVvdGF0/actions"

const FollowUpDetails = (props) => {
  //const [formData, setFormData] = useState([])
  const {
    dispatch,
    recordsMetaData,
    clientId,
    leadDetails,
    recordClientProfile,
    location,
  } = props
  let { id } = useParams()
  const history = useHistory()

  // var recordClientProfileCrossPromotion =
  //   !isEmpty(leadDetails) &&
  //   leadDetails &&
  //   leadDetails.length > 0 &&
  //   leadDetails[0].crossPromotion
  //     ? leadDetails[0].crossPromotion
  //     : ""
  const companyId =
    !isEmpty(leadDetails) && leadDetails ? leadDetails[0].companyId : ""
  console.log(recordClientProfile, "recordClientProfile")
  console.log(companyId, "companyId")
  console.log(leadDetails, "leadDetails")
  //const [addRows, setAddRows] = useState(1)

  //State details
  const [renderPage, setRenderPage] = useState(false)
  const [isEdit, setIsEdit] = useState(false)
  const [pageLoading, setPageLoading] = useState(true)
  const [addFollowupDetails, setAddFollowupDetails] = useState(false)
  const [crossPromotion, setCrossPromotion] = useState([])
  const [crossPromotionSet, setCrossPromotionSet] = useState(false)
  const [specialInstruction, setSpecialInstruction] = useState([
    {
      specialInstructionId: "",
      departmentId: "",
      teamId: "",
      departmentName: "",
      teamName: "",
      remarks: "",
    },
  ])

  const [photographyEventCheckList, setPhotographyEventCheckList] = useState([
    { description: "" },
  ])

  useEffect(() => {
    // dispatch(branchAction.loadRecord(id))
    setPageLoading(true)
    setTimeout(() => {
      setPageLoading(false)
    }, 1500)
    dispatch(quotationAction.loadServiceTotal(id))
    dispatch(followupAction.loadFollowupDetails(id))
    dispatch(followupAction.loadRejectReasonDetails())
    dispatch(followupAction.loadCompanyMetaData())
  }, [1])
  //Add followup api loader
  useEffect(() => {
    if (addFollowupDetails === true) {
      dispatch(followupAction.loadRecordsAttachmentDetailData())
      dispatch(
        followupAction.loadRecordsLeadCarryForwardListData({ leadId: id })
      )
      dispatch(followupAction.loadRecordsMetaData({ leadId: id }))
    }
  }, [addFollowupDetails])
  //Edit api loader
  useEffect(() => {
    if (isEdit === true) {
      dispatch(followupAction.loadRecordsAttachmentDetailData())
      dispatch(
        followupAction.loadRecordsLeadCarryForwardListData({ leadId: id })
      )
      dispatch(followupAction.loadRecordsMetaData({ leadId: id }))
    }
  }, [isEdit])

  const leadClientId = !isEmpty(clientId)
    ? clientId
    : location && location.state && location.state.row
    ? location.state.row.clientId
    : []
  console.log(leadClientId, "Client id")
  const quotationUpdate = useSelector(
    (specificState) => specificState.quotation
  )
  const { service_total_account } = quotationUpdate

  const followupUpdate = useSelector((specificState) => specificState.followup)
  const {
    followupRecordsMetaData = [],
    attachmentRecord = [],
    leadCarryForwardList = [],
    followup_details = [],
    reject_reason = [],
    companyMetaData = {},
  } = followupUpdate

  const budgetFromQuotation =
    service_total_account && service_total_account.totalAmount
  const budgetValue = service_total_account && service_total_account.budget

  console.log(service_total_account, "service_total_account")
  console.log(budgetFromQuotation, "budgetFromQuotation")
  console.log(companyMetaData, "companyMetaData")
  console.log(budgetValue, "budgetValue")

  const sessionUpdate = useSelector((specificState) => specificState.session)
  const { user = [] } = sessionUpdate
  const [managerView, setManagerView] = useState(false)
  const salesManagerId = !isEmpty(user) && user.roleId
  useEffect(() => {
    if (salesManagerId === "6320da65812dfec5383565f4") {
      setManagerView(true)
    } else {
      setManagerView(false)
    }
  }, [salesManagerId])

  const deviceDetect = window.navigator.userAgent
  console.log(deviceDetect, "deviceDetect")
  console.log(followup_details, "followup_details")
  console.log(reject_reason, "reject_reason")

  //Cross promotion company
  const crossPromotionCompany =
    !isEmpty(companyMetaData) &&
    companyMetaData.companyList &&
    !isEmpty(companyId)
      ? companyMetaData.companyList.filter((data) => data.value != companyId)
      : []

  console.log(crossPromotionCompany, "crossPromotionCompany")
  //Reject reason options
  const rejectReasonList =
    !isEmpty(reject_reason) &&
    reject_reason.map((c) => {
      return {
        label: c.reason,
        value: c._id,
      }
    })

  const createReasonOptions = (array) => {
    const options = []
    !isEmpty(array) &&
      array.forEach((element) => {
        let obj = {}
        ;(obj.value = element.value),
          (obj.label = element.label),
          options.push(obj)
      })
    return options
  }

  const rejectReasonOptions = createReasonOptions(rejectReasonList)

  console.log(rejectReasonOptions, "rejectReasonOptions")

  //Booking Complete Modal Start

  //Reject modal Start
  const [bookingModal, setBookingModal] = useState(false)

  const handleBookingModal = () => setBookingModal(false)
  const [bookingAttachment, setbookingAttachment] = useState([])

  const [bookingData, setBookingData] = useState({
    bookingRemarks: "",
  })
  const handleBooking = (e) => {
    setBookingData({ ...bookingData, [e.target.name]: e.target.value })
  }

  const bookingCompleteSales = (e) => {
    e.preventDefault()
    if (simpleValidator.current.allValid()) {
      const bookingComplete = {
        leadId: id,
        description: bookingData.bookingRemarks,
        // rejectReasonId: rejectStatus.value,
        attachment: bookingAttachment[0],
      }
      console.log(bookingComplete, "booking Complete")
      dispatch(salesAction.bookingCompleteList(bookingComplete))
      setTimeout(() => {
        dispatch(
          clientAction.loadRecordClientProfileById({ clientId: leadClientId })
        )
        setBookingModal(false)
      }, 2000)
    } else {
      simpleValidator.current.showMessages()
      setForceUpdate(true)
      setBookingModal(true)
      return false
    }
  }

  const bookingComplete = () => {
    setBookingData({
      rejectRemarks: "",
    })
    setBookingModal(true)
    setForceUpdate(false)
  }
  // Booking Attachment
  const handleChangeBookingAttachment = async (e) => {
    if (e.target.files) {
      var file = e.target.files
      var fileArray = Array.from(file)

      var rejectAttachmentValue = bookingAttachment

      for (let x in fileArray) {
        const formData = new FormData()
        formData.append("file", fileArray[x])
        api
          .post("/image_upload", formData)
          .then(async (res) => {
            if (res && res.data && res.data.data) {
              rejectAttachmentValue.push(res.data.data)
              await setbookingAttachment(rejectAttachmentValue)
            } else {
              alert("Upload Failed!. Please try again")
            }
          })
          .catch(() => {
            alert("Unable to Upload file")
          })
      }
      // setFFStrategy([])
    }
  }
  const subStatusOptions = !isEmpty(companyMetaData.subStatusOptions)? 
  companyMetaData.subStatusOptions.filter((m=>m.companyId === companyId)):[]
  // Sub Status Options
  // //lead sub status options
  // const leadSubStatusOptions = [
  //   { label: "Open", value: "Open" },
  //   { label: "Followup", value: "Followup" },
  //   { label: "Need time to think", value: "Need time to think" },
  //   { label: "Almost Confirm", value: "Almost Confirm" },
  //   { label: "Booked", value: "Booked" },
  //   { label: "Non Contactable", value: "Non Contactable" },
  //   {
  //     label: "Not Interested & Already Booked",
  //     value: "Not Interested & Already Booked",
  //   },
  //   {
  //     label: "Not Interested & Not Booked",
  //     value: "Not Interested & Not Booked",
  //   },
  //   { label: "Rejected", value: "Rejected" },
  //   { label: "yet to action", value: "Yet to action" },
  // ]

  //Booking Complete Modal end

  //TimeSlot Start

  const setTimeSlot = async (hour) => {
    var session = ""
    if (hour >= 9 && hour <= 11.59) {
      session = "Morning"
    } else if (hour >= 12 && hour <= 17) {
      session = "Afternoon"
    } else if (hour >= 17.01 && hour <= 21) {
      session = "Evening"
    } else {
      session = "Night"
    }
    return session
  }

  var currentDateMoment = moment().format("YYYY-MM-DD")
  var currentHourMoment = addZeroBefore(moment().format("HH"))
  var currentMiniteMoment = addZeroBefore(moment().minutes())
  var currentDateTimeMoment =
    currentDateMoment + "T" + currentHourMoment + ":" + currentMiniteMoment
  var currentTimeInputValue = currentHourMoment + ":" + currentMiniteMoment

  //Current Follow-up
  const currentFollowUpObject = {
    cFId: "",
    cFDate: currentDateMoment,
    cFTime: currentTimeInputValue,
    cFMode: "",
    cFBudget: "",
    cFClientProfile: "",
    cFLeadSubStatus: "",
    cFClientProfileRemarks: "",
    cFVip: "",
    cFReachedStatus: "",
    cFRemark: "",
    cFDestopAttachment: "",
    cFMobileAttachment: "",
    cFStatus: "",
    cFOverAllStatus: "",
    clientStatusRemark:""
  }
  const futureFollowUpObject = {
    fFId: "",
    fFdate: currentDateTimeMoment,
    fFMode: "",
    fFClientVisit: "",
    fFVisitDateTime: currentDateTimeMoment,
    fFSession: "",
    fFStrategy: "",
    fFStrategyRemark: "",
    fFSalesUrge: "",
  }
  const clientVisit = [
    { label: "Office Visit", value: "1" },
    { label: "Client Visit", value: "2" },
  ]
  const [currentFollowUp, setCurrentFollowUp] = useState(currentFollowUpObject)
  const [futureFollowUp, setFutureFollowUp] = useState(futureFollowUpObject)

  //Select box
  const [cFMode, setCFMode] = useState([])
  const [cFStatus, setCFStatus] = useState([])
  const [fFMode, setFFMode] = useState([])
  const [cFLeadSubStatus, setCFLeadSubStatus] = useState([])
  const [fFClientVisit, setFFClientVisit] = useState([])
  const [fFStrategy, setFFStrategy] = useState([])
  const [cFClientProfile, setCFClientProfile] = useState([])
  const [fFSalesUrge, setFFSalesUrge] = useState([])

  const [deleteForm, setDeleteForm] = useState(false)

  const [followupModal, setFollowupModal] = useState(false)

  const [rejectModal, setRejectModal] = useState(false)
  const [rejectStatus, setRejectStatus] = useState([])
  const [rejectAttachment, setRejectAttachment] = useState([])
  const [viewAttachmentModal, setViewAttachmentModal] = useState(false)

  const [rejectData, setRejectData] = useState({
    rejectRemarks: "",
  })
  const handleReject = (e) => {
    setRejectData({ ...rejectData, [e.target.name]: e.target.value })
  }

  const rejectLead = (e) => {
    e.preventDefault()
    if (simpleValidator.current.allValid()) {
      var attachmentData = []
      if (rejectAttachment && rejectAttachment.length > 0) {
        rejectAttachment.map((data) => {
          attachmentData.push(data)
        })
      }
      const reject_Status = {
        _id: id,
        rejectedRemarks: rejectData.rejectRemarks,
        rejectReasonId: rejectStatus.value,
        rejectAttachment: attachmentData[0],
      }
      console.log(reject_Status)
      dispatch(followupAction.addRejectStatus(reject_Status))
      setTimeout(() => {
        dispatch(
          clientAction.loadRecordClientProfileById({
            mode: "SALES",
            clientId: leadClientId,
          })
        )
        history.push("/dashboard")
      }, 2000)
      setRejectModal(false)
    } else {
      simpleValidator.current.showMessages()
      rejectForceUpdate(1)
      console.log(forceUpdate)
      setRejectModal(true)
      return false
    }
  }
  const rejectBtn = () => {
    setRejectStatus([])
    setRejectData({
      rejectRemarks: "",
    })
    setRejectModal(true)
  }
  console.log(currentFollowUp, "currentFollowUp")

  //Attachment
  const [attachmentValueArrayUpdated, setAttachmentValueArrayUpdated] =
    useState([])

  //history
  const [followupHistoryModal, setFollowupHistoryModal] = useState(false)
  const [
    followupHistoryOverallStatusyModal,
    setFollowupHistoryOverallStatusyModal,
  ] = useState(false)
  const [followupSlotModal, setFollowupSlotModal] = useState(false)

  //Attachment
  const [mobileAttachmentForm, setMobileAttachmentForm] = useState(false)
  const [destopAttachment, setDestopAttachment] = useState([])

  const [mobileAttachmentSelected, setMobileAttachmentSelected] = useState([])
  const [attachmentValidation, setAttachmentValidation] = useState(false)

  const handleChange = async (e, value) => {
    if (clientDetails.currentFollowUp == value) {
      await setCurrentFollowUp({
        ...currentFollowUp,
        [e.target.name]: e.target.value,
      })
    } else if (clientDetails.futureFollowUp == value) {
      await setFutureFollowUp({
        ...futureFollowUp,
        [e.target.name]: e.target.value,
      })
    }

    //Followup Date Change
    if (e && e.target.name == "fFdate") {
      var followupDateTime = e.target.value
      var followupDateTimeSplitone = followupDateTime.split("T")
      var followupDateTimeSplittwo = followupDateTimeSplitone[1].split(":")
      const timeslotResponse = await setTimeSlot(
        followupDateTimeSplittwo[0] + "." + followupDateTimeSplittwo[1]
      )
      var data1 = {
        ...futureFollowUp,
        [e.target.name]: e.target.value,
        ["fFVisitDateTime"]: e.target.value,
      }
      await setFutureFollowUp({ ...data1, ["fFSession"]: timeslotResponse })
    }

    //Visit date and time
    if (e && e.target.name == "fFVisitDateTime") {
      var visitDateTime = e.target.value
      var visitDateTimeSplitone = visitDateTime.split("T")
      var visitDateTimeSplittwo = visitDateTimeSplitone[1].split(":")
      const timeslotResponse = await setTimeSlot(
        visitDateTimeSplittwo[0] + "." + visitDateTimeSplittwo[1]
      )
      var data2 = {
        ...futureFollowUp,
        [e.target.name]: e.target.value,
        ["fFdate"]: e.target.value,
      }
      await setFutureFollowUp({ ...data2, ["fFSession"]: timeslotResponse })
    }
  }

  const handleClose = () => setDeleteForm(false)

  const handleChangeSelectBox = async (e, name) => {
    if (e) {
      if (name == "cFMode") {
        await setCFMode(e)
        await setCurrentFollowUp({ ...currentFollowUp, [name]: e.value })
      } else if (name == "cFStatus") {
        await setCFStatus(e)
        await setCurrentFollowUp({ ...currentFollowUp, [name]: e.value })
      } else if (name == "cFLeadSubStatus") {
        await setCFLeadSubStatus(e)
        await setCurrentFollowUp({ ...currentFollowUp, [name]: e.value })
      } else if (name == "fFMode") {
        await setFFMode(e)
        await setFutureFollowUp({ ...futureFollowUp, [name]: e.value })
      } else if (name == "fFClientVisit") {
        await setFFClientVisit(e)
        await setFutureFollowUp({ ...futureFollowUp, [name]: e.value })
      } else if (name == "fFStrategy") {
        await setFFStrategy(e)
        await setFutureFollowUp({ ...futureFollowUp, [name]: e.value })
      } else if (name == "fFSalesUrge") {
        await setFFSalesUrge(e)
        await setFutureFollowUp({ ...futureFollowUp, [name]: e.value })
      } else if (name == "cFClientProfile") {
        await setCFClientProfile(e)
        await setCurrentFollowUp({ ...currentFollowUp, [name]: e.value })
      } 
    }
  }

  const changePhotography = async (e, index) => {
    var photographyEventCheckListArray = photographyEventCheckList
    photographyEventCheckListArray[index]["description"] = e.target.value
    setPhotographyEventCheckList(photographyEventCheckListArray)
    setRenderPage(!renderPage)
  }

  const removePhotography = async (toRemove) => {
    var photographyEventCheckListArray = photographyEventCheckList
    if (toRemove != 0) {
      if (toRemove > -1) {
        photographyEventCheckListArray.splice(toRemove, 1)
      }
      setPhotographyEventCheckList(photographyEventCheckListArray)
      setRenderPage(!renderPage)
    }
  }

  const changeSpecialInstruction = async (e, index, name) => {
    var specialInstructionList = specialInstruction
    if (name == "remarks") {
      e = e.target.value
      specialInstructionList[index][name] = e
      setSpecialInstruction(specialInstructionList)
    }
    if (name == "departmentId") {
      specialInstructionList[index]["departmentId"] = e.value
      specialInstructionList[index]["departmentName"] = e.label
      setSpecialInstruction(specialInstructionList)
    }
    if (name == "teamId") {
      specialInstructionList[index]["teamId"] = e.value
      specialInstructionList[index]["teamName"] = e.label
      setSpecialInstruction(specialInstructionList)
    }
    setRenderPage(!renderPage)
  }

  const removeSpecialInstruction = async (toRemove) => {
    var specialInstructionList = specialInstruction
    if (toRemove != 0) {
      if (toRemove > -1) {
        specialInstructionList.splice(toRemove, 1)
      }
      setSpecialInstruction(specialInstructionList)
      setRenderPage(!renderPage)
    }
  }

  const addPhotography = async () => {
    setPhotographyEventCheckList([
      ...photographyEventCheckList,
      { description: "" },
    ])
    setRenderPage(true)
  }
  const addSpecialInstruction = async () => {
    setSpecialInstruction([
      ...specialInstruction,
      { specialInstructionId: "", departmentId: "", teamId: "", remarks: "" },
    ])
    setRenderPage(true)
  }

  const handleChangeCrossOver = async (e, id) => {
    crossPromotion.map(function (item) {
      if (item.id == id) {
        var selectedCheckBox = e.target.value
        let updateCrossJson = item
        if (isEdit && updateCrossJson.action == true) {
          selectedCheckBox = "yes"
        }
        updateCrossJson.action =
          selectedCheckBox && selectedCheckBox == "yes"
            ? true
            : selectedCheckBox && selectedCheckBox == "no"
            ? false
            : ""
      }
    })

    await setCrossPromotion(crossPromotion)
  }

  const followupTableDetails = !isEmpty(followup_details)
    ? followup_details
    : []
  const followupCompanyDetails = get(followupRecordsMetaData, "companyList", [])
  const followupDepartmentDetails = get(
    followupRecordsMetaData,
    "departmentList",
    []
  )
  const followupTeamDetails = get(followupRecordsMetaData, "teamList", [])
  const overallLeadDetails = get(followupRecordsMetaData, "overallLeadList", [])
  const followupRemarksHistoryDetails = get(
    followupRecordsMetaData,
    "followupRemarksHistoryList",
    []
  )

  const leadCarryForwardListCheckList = get(
    leadCarryForwardList,
    "checkList",
    []
  )
  const leadCarryForwardListSpecialInstruction = get(
    leadCarryForwardList,
    "specialInstruction",
    []
  )

  console.log(leadCarryForwardListCheckList, followupCompanyDetails)
  console.log(leadCarryForwardListSpecialInstruction)

  //History List Start
  const overallLeadDetailsUpdated = !isEmpty(overallLeadDetails)
    ? overallLeadDetails.map((followup, index) => {
        return {
          key: index,
          id: get(followup, "_id", ""),
          name: get(followup, "insertedBy.name", ""),
          overallStatus: get(followup, "overallStatus", ""),
          historyDate: followup.createdAt
            ? moment(followup.createdAt).format("DD-MM-YYYY")
            : "",
        }
      })
    : []

  const followupRemarksHistoryDetailsUpdated = !isEmpty(
    followupRemarksHistoryDetails
  )
    ? followupRemarksHistoryDetails.map((followup, index) => {
        return {
          key: index,
          id: get(followup, "_id", ""),
          name: get(followup, "insertedBy.name", ""),
          remarks: get(followup, "remarks", ""),
          historyDate: followup.createdAt
            ? moment(followup.createdAt).format("DD-MM-YYYY")
            : "",
        }
      })
    : []

  const timeslotDetailsUpdated = []
  //History List End

  //Attatchment Data
  const attachmentRecordUpdated = !isEmpty(attachmentRecord)
    ? attachmentRecord.map((attachment, index) => {
        var attachmentFile = attachment.attachment
        var attachmentFileExtenstion = attachmentFile.split(".")
        var attachmentFileExtenstionType =
          attachmentFileExtenstion[attachmentFileExtenstion.length - 1]
        var attachmentType = "file"

        if (attachmentFileExtenstionType) {
          if (
            attachmentFileExtenstionType == "jpg" ||
            attachmentFileExtenstionType == "png" ||
            attachmentFileExtenstionType == "jpeg"
          ) {
            attachmentType = "image"
          } else if (
            attachmentFileExtenstionType == "mp3" ||
            attachmentFileExtenstionType == "wav" ||
            attachmentFileExtenstionType == "mp4" ||
            attachmentFileExtenstionType == "m4a" ||
            attachmentFileExtenstionType == "m4b" ||
            attachmentFileExtenstionType == "msv" ||
            attachmentFileExtenstionType == "mmf" ||
            attachmentFileExtenstionType == "m4p" ||
            attachmentFileExtenstionType == "wma" ||
            attachmentFileExtenstionType == "aac" ||
            attachmentFileExtenstionType == "ac3" ||
            attachmentFileExtenstionType == "aiff" ||
            attachmentFileExtenstionType == "flac" ||
            attachmentFileExtenstionType == "ogg" ||
            attachmentFileExtenstionType == "opus" ||
            attachmentFileExtenstionType == "ts" ||
            attachmentFileExtenstionType == "wav" ||
            attachmentFileExtenstionType == "amr"
          ) {
            attachmentType = "audio"
          }
        }

        return {
          key: index,
          id: get(attachment, "_id", ""),
          customerDetails: get(attachment, "customerDetails", ""),
          description: get(attachment, "description", ""),
          pickDateTime: get(attachment, "pickDateTime", ""),
          attachment: get(attachment, "attachment", ""),
          attachmentType: attachmentType,
        }
      })
    : []
  const followupCompanyDetailsUpdated = !isEmpty(crossPromotionCompany)
    ? crossPromotionCompany.map((followup, index) => {
        // var actionMetaValue = ""
        // if (recordClientProfileCrossPromotion) {
        //   const actionMeta = recordClientProfileCrossPromotion.filter(
        //     (data) => data.companyId == followup.value
        //   )
        //   actionMetaValue =
        //     actionMeta && actionMeta[0] && actionMeta[0].action == true
        //       ? actionMeta[0].action
        //       : actionMeta && actionMeta[0] && actionMeta[0].action == false
        //       ? actionMeta[0].action
        //       : ""
        // }
        return {
          key: index,
          id: get(followup, "value", ""),
          companyName: get(followup, "label", "--"),
          action:"",
          crossOverId: "",
        }
      })
    : []

  if (
    followupCompanyDetailsUpdated &&
    followupCompanyDetailsUpdated.length > 0 &&
    !crossPromotionSet &&
    followupModal == true
  ) {
    setCrossPromotion(followupCompanyDetailsUpdated)
    setCrossPromotionSet(true)
  }

  console.log(crossPromotion, "crossPromotion")
  console.log(followupCompanyDetailsUpdated, "companyDetails")

  let followupBudget = 0
  const followupTable = !isEmpty(followupTableDetails)
    ? followupTableDetails.map((followup, index) => {
        followupBudget = get(followup, "budget", 0)
        return {
          key: index,
          sNo: index + 1,
          id: get(followup, "_id", ""),
          followupDate: get(followup, "followupDate", "--"),
          followupTime: get(followup, "followupTime", "--"),
          budget: get(followup, "budget", "--"),
          overAllStatus: get(followup, "overallStatus", ""),
          attachment: get(followup, "attachment", ""),
          modeName: get(followup, "modeName", ""),
          clientReachedStatus: get(followup, "clientReachedStatus", ""),
          isEditFollowup: get(followup, "isEditFollowup", ""),
          futureFollowupDate: get(followup.futureFollowup, "followupDate", ""),
          followupEditDetails: followup ? followup : [],
        }
      })
    : []

  //Validator
  const simpleValidator = useRef(new SimpleReactValidator())
  const [forceUpdate, setForceUpdate] = useState(false)
  const [, rejectForceUpdate] = useState()
  //salesUrgeOptions

  const salesUrgeOptions = [
    {
      label: "hot",
      value: "hot",
    },
    {
      label: "warm",
      value: "warm",
    },
    {
      label: "cold",
      value: "cold",
    },
  ]

  //Form submission
  const handleSubmit = (e) => {
    e.preventDefault()
   
    const crossPromotionData = !isEmpty(crossPromotion)
      ? crossPromotion.map((data) => {
          if (
           
            data.action != "" ||
            data.action === false ||
            data.action === true
          ) {
            return {
              companyId: data.id,
              action: data.action,
            }
          }
        })
      : []

    //specialInstruction data
    const specialInstructionData = !isEmpty(specialInstruction)
      ? specialInstruction.map((data) => {
          if (data.departmentId && data.teamId) {
            return {
              departmentId: data.departmentId ? data.departmentId : "",
              teamId: data.teamId ? data.teamId : "",
              remarks: data.remarks ? data.remarks : "",
            }
          }
        })
      : []

    //Attachment start
    var AttachmentValue = []
    if (destopAttachment && destopAttachment.length > 0) {
      destopAttachment.map((data) => {
        AttachmentValue.push(data)
      })
      setAttachmentValidation(false)
    } else if (
      mobileAttachmentSelected &&
      mobileAttachmentSelected.length > 0
    ) {
      mobileAttachmentSelected.map((data) => {
        AttachmentValue.push(data.attachment)
      })
      setAttachmentValidation(false)
    } else {
      setAttachmentValidation(true)
    }
    //Attachment end

    if (
      simpleValidator.current.allValid() &&
      AttachmentValue &&
      AttachmentValue.length > 0
    ) {
      var visitDateAndTime = futureFollowUp.fFVisitDateTime
      var visitDateTimeSplitone = visitDateAndTime.split("T")
      var visitDateAndTimeFinal =
        visitDateTimeSplitone[0] + " " + visitDateTimeSplitone[1] + ":00"

      var submitValue = {
        leadId: id,
        crossPromotion: crossPromotionData.filter(function (el) {
          return el != null
        }),
        specialInstruction: specialInstructionData.filter(function (el) {
          return el != null
        }),
        checkList: photographyEventCheckList.filter(function (el) {
          return el != null
        }),
        currentFollowup: {
          followupDate: currentFollowUp.cFDate,
          followupTime: currentFollowUp.cFTime,
          mode: currentFollowUp.cFMode,
          followupStatus: currentFollowUp.cFStatus,
          leadSubStatus: currentFollowUp.cFLeadSubStatus,
          budget: currentFollowUp.cFBudget,
          clientProfile: currentFollowUp.cFClientProfile,
          clientProfileRemarks: currentFollowUp.cFClientProfileRemarks,
          clientProfileStatus: !isEmpty(currentFollowUp.cFVip)
            ? currentFollowUp.cFVip
            : null,
          clientReachedStatus: currentFollowUp.cFReachedStatus,
          remarks: currentFollowUp.cFRemark,
          recordAttachment: AttachmentValue,
          overallStatus: currentFollowUp.cFOverAllStatus,
          salesUrge: fFSalesUrge.value,
          clientStatusRemark:currentFollowUp.clientStatusRemark
        },
        futureFollowup: {
          followupDate: futureFollowUp.fFdate,
          mode: futureFollowUp.fFMode,
          clientVisit: futureFollowUp.fFClientVisit,
          visitDateTime: visitDateAndTimeFinal,
          session: futureFollowUp.fFSession,
          followupStrategyId: futureFollowUp.fFStrategy,
          strategyRemark: futureFollowUp.fFStrategyRemark,
          // futureFollowupSalesUrge: futureFollowUp.fFSalesUrge,
        },
      }

      dispatch(followupAction.createFollowupRecord(submitValue))

      if (mobileAttachmentSelected && mobileAttachmentSelected.length > 0) {
        const mobileAttachmentSelectedIdData = !isEmpty(
          mobileAttachmentSelected
        )
          ? mobileAttachmentSelected.map((data) => {
              return data.id
            })
          : []
        if (
          mobileAttachmentSelectedIdData &&
          mobileAttachmentSelectedIdData.length > 0
        ) {
          var objectValue = {
            callUploadId: mobileAttachmentSelectedIdData,
            status: 2,
          }
          dispatch(
            followupAction.uploadFollowupAttachmentRecordData(objectValue)
          )
        }
      }
      setDestopAttachment([])
      setMobileAttachmentSelected([])

      setTimeout(() => {
        dispatch(followupAction.loadFollowupDetails(id))
        dispatch(
          clientAction.loadRecordClientProfileById({ clientId: leadClientId })
        )
        toast.success("Followup Details Created Successfully", {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 1000,
        })
        setFollowupModal(false)
      }, 2000)
    } else {
      simpleValidator.current.showMessages()
      setForceUpdate(true)
      console.log(forceUpdate)
      return false
    }
    setTimeout(() => {
      dispatch(
        followupAction.loadRecordsLeadCarryForwardListData({ leadId: id })
      )
      dispatch(followupAction.loadFollowCronDetails(id))
    }, 3000)
  }

  //Update
  const handleUpdate = (e) => {
    e.preventDefault()

    // const crossPromotionData = !isEmpty(crossPromotion)
    //   ? crossPromotion.map((data) => {
    //       if (
    //         data.action != "" ||
    //         data.action === false ||
    //         data.action === true
    //       ) {
    //         return {
    //           _id: data.crossOverId,
    //           companyId: data.id,
    //           action: data.action,
    //         }
    //       }
    //     })
    //   : []

    //specialInstruction data

    const specialInstructionData = !isEmpty(specialInstruction)
      ? specialInstruction.map((data) => {
          if (data.departmentId && data.teamId) {
            return {
              _id: data.specialInstructionId ? data.specialInstructionId : "",
              departmentId: data.departmentId ? data.departmentId : "",
              teamId: data.teamId ? data.teamId : "",
              remarks: data.remarks ? data.remarks : "",
            }
          }
        })
      : []

    //checklist data
    const photographyEventCheckListData = !isEmpty(photographyEventCheckList)
      ? photographyEventCheckList.map((data) => {
          if (data.description) {
            return {
              _id: data.checkListId ? data.checkListId : "",
              description:
                data.description && data.description ? data.description : "",
            }
          }
        })
      : []

    //Attachment start
    var AttachmentValue = []
    if (destopAttachment && destopAttachment.length > 0) {
      destopAttachment.map((data) => {
        AttachmentValue.push(data)
      })
      setAttachmentValidation(false)
    } else if (
      mobileAttachmentSelected &&
      mobileAttachmentSelected.length > 0
    ) {
      mobileAttachmentSelected.map((data) => {
        AttachmentValue.push(data.attachment)
      })
      setAttachmentValidation(false)
    }else {
      setAttachmentValidation(true)
    }
    //Attachment end

    if (simpleValidator.current.allValid()&& AttachmentValue &&
    AttachmentValue.length > 0 ) {
      var submitValue = {
        leadId: id,
        // crossPromotion: crossPromotionData.filter(function (el) {
        //   return el != null
        // }),
        specialInstruction: specialInstructionData,
        checkList: photographyEventCheckListData,
        currentFollowup: {
          _id: currentFollowUp.cFId,
          followupDate: currentFollowUp.cFDate,
          followupTime: currentFollowUp.cFTime,
          mode: currentFollowUp.cFMode,
          followupStatus: currentFollowUp.cFStatus,
          leadSubStatus: currentFollowUp.cFLeadSubStatus,
          budget: currentFollowUp.cFBudget,
          clientProfile: currentFollowUp.cFClientProfile,
          clientProfileRemarks: currentFollowUp.cFClientProfileRemarks,
          clientProfileStatus: !isEmpty(currentFollowUp.cFVip)
            ? currentFollowUp.cFVip
            : null,
          clientReachedStatus: currentFollowUp.cFReachedStatus,
          remarks: currentFollowUp.cFRemark,
          recordAttachment: AttachmentValue,
          overallStatus: currentFollowUp.cFOverAllStatus,
          salesUrge: fFSalesUrge.value,
          clientStatusRemark:currentFollowUp.clientStatusRemark
        },
        futureFollowup: {
          _id: futureFollowUp.fFId,
          followupDate: futureFollowUp.fFdate,
          mode: futureFollowUp.fFMode,
          clientVisit: futureFollowUp.fFClientVisit,
          visitDateTime: futureFollowUp.fFVisitDateTime,
          session: futureFollowUp.fFSession,
          followupStrategyId: futureFollowUp.fFStrategy,
          strategyRemark: futureFollowUp.fFStrategyRemark,
        },
      }

      dispatch(followupAction.updateFollowupRecord(submitValue))

      if (mobileAttachmentSelected && mobileAttachmentSelected.length > 0) {
        const mobileAttachmentSelectedIdData = !isEmpty(
          mobileAttachmentSelected
        )
          ? mobileAttachmentSelected.map((data) => {
              return data.id
            })
          : []
        if (
          mobileAttachmentSelectedIdData &&
          mobileAttachmentSelectedIdData.length > 0
        ) {
          var objectValue = {
            callUploadId: mobileAttachmentSelectedIdData,
            status: 2,
          }
          dispatch(
            followupAction.uploadFollowupAttachmentRecordData(objectValue)
          )
        }
      }
      setDestopAttachment([])
      setMobileAttachmentSelected([])

      setTimeout(() => {
        // dispatch(followupAction.loadRecordsMetaData({ leadId: id }))
        dispatch(followupAction.loadFollowupDetails(id))
        dispatch(
          clientAction.loadRecordClientProfileById({ clientId: leadClientId })
        )
        dispatch(followupAction.loadFollowCronDetails(id))
      }, 3000)

      toast.success("Followup Details Updated Successfully", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1000,
      })

      setFollowupModal(false)
    } else {
      simpleValidator.current.showMessages()
      setForceUpdate(true)
      console.log(forceUpdate)
      return false
    }
    setTimeout(() => {
      dispatch(
        followupAction.loadRecordsLeadCarryForwardListData({ leadId: id })
      )
    }, 5000)
  }

  // Edit screen
  const editFollowupDetails = (value) => {
    //Attachment Start
    var attachmentValue = value.followupEditDetails.recordAttachment
    var attachmentValueArrayLoopUpdated = []
    if (attachmentValue && attachmentValue.length > 0) {
      for (let i = 0; i < attachmentValue.length; i++) {
        var fileAttachment = attachmentValue[i]
        var attachmentFileExtenstion = fileAttachment.split(".")
        var attachmentFileExtenstionType =
          attachmentFileExtenstion[attachmentFileExtenstion.length - 1]
        var attachmentType = "file"

        if (attachmentFileExtenstionType) {
          if (
            attachmentFileExtenstionType == "jpg" ||
            attachmentFileExtenstionType == "png" ||
            attachmentFileExtenstionType == "jpeg"
          ) {
            attachmentType = "image"
          } else if (
            attachmentFileExtenstionType == "mp3" ||
            attachmentFileExtenstionType == "wav" ||
            attachmentFileExtenstionType == "mp4" ||
            attachmentFileExtenstionType == "m4a" ||
            attachmentFileExtenstionType == "m4b" ||
            attachmentFileExtenstionType == "msv" ||
            attachmentFileExtenstionType == "mmf" ||
            attachmentFileExtenstionType == "m4p" ||
            attachmentFileExtenstionType == "wma" ||
            attachmentFileExtenstionType == "aac" ||
            attachmentFileExtenstionType == "ac3" ||
            attachmentFileExtenstionType == "aiff" ||
            attachmentFileExtenstionType == "flac" ||
            attachmentFileExtenstionType == "ogg" ||
            attachmentFileExtenstionType == "opus" ||
            attachmentFileExtenstionType == "ts" ||
            attachmentFileExtenstionType == "wav" ||
            attachmentFileExtenstionType == "amr"
          ) {
            attachmentType = "audio"
          }
        }
        attachmentValueArrayLoopUpdated.push({
          attachmentType: attachmentType,
          file: fileAttachment,
        })
      }
    }
    setAttachmentValueArrayUpdated(attachmentValueArrayLoopUpdated)
    //Attachment End
    setDestopAttachment(attachmentValue)
    setMobileAttachmentSelected(attachmentValue)
    value = value.followupEditDetails
    console.log(value, "edit value")
    setIsEdit(true)
    setFollowupModal(true)
    setCFMode({ value: value.mode, label: value.modeName })
    setCFClientProfile({
      value: value.clientProfile,
      label: value.clientProfileName,
    })
    setCFStatus({
      value: value.followupStatus,
      label: value.followupStatusAction,
    })
    setCFLeadSubStatus({
      value: value.leadSubStatus,
      label: value.leadSubStatus,
    })

    setCurrentFollowUp({
      cFId: value._id ? value._id : "",
      cFDate: value.followupDate ? value.followupDate : "",
      cFTime: value.followupTime ? value.followupTime : "",
      cFMode: value.mode ? value.mode : "",
      cFBudget: value.budget ? value.budget : "",
      cFClientProfile: value.clientProfile ? value.clientProfile : "",
      cFClientProfileRemarks: value.clientProfileRemarks
        ? value.clientProfileRemarks
        : "",
      cFVip: value.clientProfileStatus ? value.clientProfileStatus : "",
      cFReachedStatus: value.clientReachedStatus
        ? value.clientReachedStatus
        : "",
      cFRemark: value.remarks ? value.remarks : "",
      cFDestopAttachment: "",
      cFMobileAttachment: "",
      cFStatus: value.followupStatus ? value.followupStatus : "",
      cFOverAllStatus: value.overallStatus ? value.overallStatus : "",
      cFLeadSubStatus: value.leadSubStatus ? value.leadSubStatus : "",
      clientStatusRemark:value.clientStatusRemark?value.clientStatusRemark:""
    })

    var visitDateTimeFutureFollowup =
      value.futureFollowup && value.futureFollowup.visitDateTime
        ? value.futureFollowup.visitDateTime
        : ""
    if (visitDateTimeFutureFollowup) {
      var visitDateTimeSplitone = visitDateTimeFutureFollowup.split("T")
      var visitDateTimeSplittwo = visitDateTimeSplitone[1].split(":")
      visitDateTimeFutureFollowup =
        visitDateTimeSplitone[0] +
        "T" +
        visitDateTimeSplittwo[0] +
        ":" +
        visitDateTimeSplittwo[1] +
        ":00"
    }

    var futureDateTimeFutureFollowup =
      value.futureFollowup && value.futureFollowup.followupDate
        ? value.futureFollowup.followupDate
        : ""
    if (futureDateTimeFutureFollowup) {
      var futureDateTimeSplitone = futureDateTimeFutureFollowup.split("T")
      var futureDateTimeSplittwo = futureDateTimeSplitone[1].split(":")
      futureDateTimeFutureFollowup =
        futureDateTimeSplitone[0] +
        "T" +
        futureDateTimeSplittwo[0] +
        ":" +
        futureDateTimeSplittwo[1] +
        ":00"
    }
    const clientVisitLabel = value?.futureFollowup?.clientVisit

    if (clientVisitLabel) {
      const matchingClientVisit = clientVisit.find(
        (data) => data.label === clientVisitLabel
      )
  
      if (matchingClientVisit) {
        setFFClientVisit({
          label: clientVisitLabel,
          value: matchingClientVisit.value,
        })
      }
    }
    // const clientVisitSelected = clientVisit.find(
    //   (data) => data.label == value.futureFollowup.clientVisit
    // ).value
    // setFFClientVisit({label:value.futureFollowup.clientVisit , value:clientVisitSelected})
    setFFMode({
      value: value?.futureFollowup?.mode || "",
      label: value?.futureFollowup?.modeName || "",
    })
    setFFStrategy({
      value: value?.futureFollowup?.followupStrategyId || "",
      label: value?.futureFollowup?.followupStrategyName || "",
    })
    setFFSalesUrge({
      value: value.salesUrge,
      label: value.salesUrge,
    })
    setFutureFollowUp({
      fFId:
        value.futureFollowup && value.futureFollowup._id
          ? value.futureFollowup._id
          : "",
      fFdate: futureDateTimeFutureFollowup,
      fFMode:
        value.futureFollowup && value.futureFollowup.mode
          ? value.futureFollowup.mode
          : "",
      fFClientVisit:
        value.futureFollowup && value.futureFollowup.clientVisit
          ? value.futureFollowup.clientVisit
          : "",
      fFVisitDateTime: visitDateTimeFutureFollowup,
      fFSession:
        value.futureFollowup && value.futureFollowup.session
          ? value.futureFollowup.session
          : "",
      fFStrategy:
        value.futureFollowup && value.futureFollowup.followupStrategyId
          ? value.futureFollowup.followupStrategyId
          : "",
      fFStrategyRemark:
        value.futureFollowup && value.futureFollowup.strategyRemark
          ? value.futureFollowup.strategyRemark
          : "",
      fFSalesUrge: value && value.salesUrge ? value.salesUrge : "",
    })

    //followupCompanyDetails
    var followupCompanyDetailsEdit = value.crossPromotion
    const followupCompanyDetailsEditUpdated = !isEmpty(
      followupCompanyDetailsEdit
    )
      ? followupCompanyDetailsEdit.map((followup, index) => {
          return {
            key: index,
            id: get(followup, "companyId", ""),
            companyName: get(followup, "companyName", "--"),
            crossOverId: get(followup, "_id", ""),
            action: get(followup, "action", ""),
          }
        })
      : []
      console.log(followupCompanyDetailsEditUpdated,"followupCompanyDetailsEditUpdated")
      console.log(followupCompanyDetailsEdit,"followupCompanyDetailsEdit")
    setCrossPromotion(followupCompanyDetailsEditUpdated)

    //special instruction

    var specialInstructionDetailsEdit = value.specialInstruction

    const specialInstructionDetailsEditUpdated = !isEmpty(
      specialInstructionDetailsEdit
    )
      ? specialInstructionDetailsEdit.map((specialInstruction, index) => {
          return {
            key: index,
            specialInstructionId: get(specialInstruction, "_id", ""),
            departmentId: get(specialInstruction, "departmentId", ""),
            teamId: get(specialInstruction, "teamId", ""),
            departmentName: get(specialInstruction, "departmentName", ""),
            teamName: get(specialInstruction, "teamName", ""),
            remarks: get(specialInstruction, "remarks", ""),
          }
        })
      : []
    setSpecialInstruction(specialInstructionDetailsEditUpdated)

    //Check List
    var checkListDetailsEdit = value.checkList
    const checkListDetailsEditUpdated = !isEmpty(checkListDetailsEdit)
      ? checkListDetailsEdit.map((checkList, index) => {
          return {
            key: index,
            checkListId: get(checkList, "_id", ""),
            description: get(checkList, "description", ""),
          }
        })
      : []
    setPhotographyEventCheckList(checkListDetailsEditUpdated)

    setRenderPage(!renderPage)
    setForceUpdate(false)
  }

  const handleCancel = () => {
    setFollowupModal(false)
  }

  const followupHistoryFollowUpRemark = () => {
    setFollowupHistoryModal(true)
  }

  const followupHistoryOverallStatus = () => {
    setFollowupHistoryOverallStatusyModal(true)
  }

  const followupSlot = () => {
    setFollowupSlotModal(true)
  }
  const cFClientProfileName =
    !isEmpty(recordClientProfile) && recordClientProfile

  const followupClientProfile =
    !isEmpty(leadDetails) && leadDetails ? leadDetails : []
  const profileRemarksClient =
    !isEmpty(recordClientProfile) && recordClientProfile.clientProfileRemark
  const clientStatusRemarkAddedValue =  !isEmpty(recordClientProfile)? recordClientProfile.clientStatusRemark : ""
  const handleAddFollowup = async () => {
    setFollowupModal(true)
    setAddFollowupDetails(true)
    setCurrentFollowUp(currentFollowUpObject)
    setCurrentFollowUp({
      cFId: "",
      cFDate: currentDateMoment,
      cFTime: currentTimeInputValue,
      cFMode: "",
      cFBudget: budgetFromQuotation > 0 ? budgetValue : followupBudget,
      cFClientProfileRemarks: profileRemarksClient,
      cFVip: "",
      cFReachedStatus: "",
      cFRemark: "",
      cFDestopAttachment: "",
      cFMobileAttachment: "",
      cFClientProfile: cFClientProfileName.clientProfile.value,
      cFStatus: "",
      cFLeadSubStatus: followupClientProfile[0].leadSubStatus,
      cFOverAllStatus: "",
      clientStatusRemark:clientStatusRemarkAddedValue
    })
    var currentHourMomentLoad = addZeroBefore(moment().format("HH"))
    var currentMiniteMomentLoad = addZeroBefore(moment().minutes())
    const timeslotResponse = await setTimeSlot(
      currentHourMomentLoad + "." + currentMiniteMomentLoad
    )
    setFutureFollowUp({
      fFId: "",
      fFdate: currentDateTimeMoment,
      fFMode: "",
      fFClientVisit: "",
      fFVisitDateTime: currentDateTimeMoment,
      fFSession: timeslotResponse,
      fFStrategy: "",
      fFStrategyRemark: "",
      fFSalesUrge: followupClientProfile[0].salesUrge,
    })
    // setFFSalesUrge({label: followupClientProfile[0].salesUrge, value: followupClientProfile[0].salesUrge})

    setCFMode([])
    setCFStatus([])
    setFFMode([])
    setFFClientVisit([])
    setFFStrategy([])
    setDestopAttachment([])
    setMobileAttachmentSelected([])
    setIsEdit(false)
    setPhotographyEventCheckList([{ description: "" }])
    setSpecialInstruction([
      {
        specialInstructionId: "",
        departmentId: "",
        teamId: "",
        remarks: "",
      },
    ])

    const followupCompanyDetailsUpdated = !isEmpty(crossPromotionCompany)
      ? crossPromotionCompany.map((followup, index) => {
          // var actionMetaValue = ""
          // if (recordClientProfileCrossPromotion) {
          //   const actionMeta = recordClientProfileCrossPromotion.filter(
          //     (data) => data.companyId == followup.value
          //   )
          //   actionMetaValue =
          //     actionMeta && actionMeta[0] && actionMeta[0].action == true
          //       ? actionMeta[0].action
          //       : actionMeta && actionMeta[0] && actionMeta[0].action == false
          //       ? actionMeta[0].action
          //       : ""
          // }
          return {
            key: index,
            id: get(followup, "value", ""),
            companyName: get(followup, "label", "--"),
            action:"",
            crossOverId: "",
          }
        })
      : []

    setCrossPromotion(followupCompanyDetailsUpdated)
    setCrossPromotionSet(true)

    // var currentHourMomentLoad = addZeroBefore(moment().format("HH"))
    // var currentMiniteMomentLoad = addZeroBefore(moment().minutes())
    // const timeslotResponse = await setTimeSlot(
    //   currentHourMomentLoad + "." + currentMiniteMomentLoad
    // )
    // await setFutureFollowUp({
    //   ...futureFollowUp,
    //   ["fFSession"]: timeslotResponse,
    // })
  }

  //Delete Event
  const removeApiFollowupDetails = () => {
    setDeleteForm(false)
    // dispatch(eventAction.deleteEventRecord(event.id))
    // const newEvent = formData.filter((form) => form.id !== event.id)
    // setFormData(newEvent)
  }

  // const addZeroBefore = async(number)=> {
  //   return  number && number.length == 1 ? '0'+number : number
  // }

  function addZeroBefore(number) {
    var numberString = "0" + number
    if (number < 10) {
      return numberString
    } else {
      return number
    }
  }

  useEffect(() => {}, [1])

  // Attachment start
  const inputDesktopAttachmentFile = useRef(null)
  const handleCloseAttachment = () => {
    setMobileAttachmentForm(false)
    setMobileAttachmentSelected([])
  }
  const handleSubmitAttachment = async () => {
    setMobileAttachmentForm(false)
  }

  const handleChangeDesktopAttachment = async (e, renderPage) => {
    if (e.target.files) {
      await setMobileAttachmentSelected([])
      var files = e.target.files
      var filesArray = Array.from(files)

      var destopAttachmentValue = destopAttachment

      for (let x in filesArray) {
        const formData = new FormData()
        formData.append("file", filesArray[x])
        api
          .post("/image_upload", formData)
          .then(async (res) => {
            if (res && res.data && res.data.data) {
              destopAttachmentValue.push(res.data.data)
              await setDestopAttachment(destopAttachmentValue)
              await setRenderPage(!renderPage)
            } else {
              alert("Upload Failed!. Please try again")
            }
          })
          .catch(() => {
            alert("Unable to Upload file")
          })
      }
      await setAttachmentValidation(false)
      await setMobileAttachmentForm(false)
      // setFFStrategy([])
    }
  }

  const handleClickAttachment = async (value) => {
    if (value == "desktop") {
      await setDestopAttachment([])
      inputDesktopAttachmentFile.current.click()
    }

    if (value == "mobile") {
      setMobileAttachmentForm(true)
      setMobileAttachmentSelected([])
    }
  }

  const handleChangeAttachmentCheckbox = async (
    e,
    valueId,
    valueAttachment
  ) => {
    setDestopAttachment([])
    var selectedValue = mobileAttachmentSelected
    if (e.target.checked) {
      selectedValue.push({ id: valueId, attachment: valueAttachment })
    } else {
      const index = selectedValue.indexOf(valueId)
      if (index > -1) {
        selectedValue.splice(index, 1)
      }
    }
    setMobileAttachmentSelected(selectedValue)
    setAttachmentValidation(false)
    setRenderPage(false)
  }
  // Attachment end
  const handleChangeRejectAttachment = async (e) => {
    if (e.target.files) {
      var file = e.target.files
      var fileArray = Array.from(file)

      var rejectAttachmentValue = rejectAttachment

      for (let x in fileArray) {
        const formData = new FormData()
        formData.append("file", fileArray[x])
        api
          .post("/image_upload", formData)
          .then(async (res) => {
            if (res && res.data && res.data.data) {
              rejectAttachmentValue.push(res.data.data)
              await setRejectAttachment(rejectAttachmentValue)
            } else {
              alert("Upload Failed!. Please try again")
            }
          })
          .catch(() => {
            alert("Unable to Upload file")
          })
      }
      // setFFStrategy([])
    }
  }

  useEffect(() => {
    if (followupClientProfile.length > 0) {
      setCFClientProfile({
        label: cFClientProfileName.clientProfile.clientProfleName,
        value: cFClientProfileName.clientProfile.value,
      })

      setFFSalesUrge({
        label: followupClientProfile[0].salesUrge,
        value: followupClientProfile[0].salesUrge,
      })

      setCurrentFollowUp({
        ...currentFollowUp,
        cFClientProfile: [
          {
            label: cFClientProfileName.clientProfile.clientProfleName,
            value: cFClientProfileName.clientProfile.value,
          },
        ],
        cFLeadSubStatus: [
          {
            label: followupClientProfile[0].leadSubStatus,
            value: followupClientProfile[0].leadSubStatus,
          },
        ],
      })
    }
    setFutureFollowUp({
      ...futureFollowUp,
      fFSalesUrge: [
        {
          label: followupClientProfile[0].salesUrge,
          value: followupClientProfile[0].salesUrge,
        },
      ],
    })
  }, [followupClientProfile])

  return (
    <React.Fragment>
      <Row>
        {/* Event Details Section */}
        <Col
          style={{
            display: "flex",
            alignItems: "center",
            paddingTop: "20px",
            paddingBottom: "15px",
          }}
        >
          <p
            style={{
              color: "#4486eb",
              margin: "0px",
              marginRight: "15px",
              fontSize: "16px",
              fontWeight: "500",
            }}
          >
            Current Follow-up
          </p>
          <>
            {pageLoading ? (
              <button
                style={{
                  color: "#adb5bd",
                  border: "1.8px solid #ced4da",
                  borderRadius: "4px",
                  padding: "4px 10px",
                  height: "30px",
                  width: "max-content",
                  textAlign: "center",
                  cursor: "pointer",
                  marginLeft: "10px",
                }}
                className={
                  managerView ? "bg-white disabled-button" : "bg-white"
                }
                disabled
              >
                <i className="fas fa-plus"></i> Add New
              </button>
            ) : (
              <button
                style={{
                  color: "#34C28F",
                  border: "1.8px solid #34C28F",
                  borderRadius: "4px",
                  padding: "4px 10px",
                  height: "30px",
                  width: "max-content",
                  textAlign: "center",
                  cursor: "pointer",
                  marginLeft: "10px",
                }}
                onClick={() => {
                  handleAddFollowup()
                }}
                className={
                  managerView ? "bg-white disabled-button" : "bg-white"
                }
              >
                <i className="fas fa-plus"></i> Add New
              </button>
            )}

            <button
              style={{
                color: "#e40d8c",
                border: "1.8px solid #e40d8c",
                borderRadius: "4px",
                padding: "4px 10px",
                height: "30px",
                width: "max-content",
                textAlign: "center",
                cursor: "pointer",
                marginLeft: "10px",
              }}
              // onClick={() => setFollowupModal(true)}
              className={managerView ? "bg-white disabled-button" : "bg-white"}
            >
              <i className="fas fa-plus"></i> Create New Quote
            </button>
          </>
          <div
            style={{
              color: "#eb0000",
              border: "1.8px solid #eb0000",
              borderRadius: "4px",
              padding: "4px 10px",
              height: "30px",
              width: "max-content",
              textAlign: "center",
              cursor: "pointer",
              marginLeft: "10px",
            }}
            onClick={() => {
              rejectBtn()
            }}
          >
            <i className="fas fa-trash"></i> Reject Lead
          </div>
          <div
            style={
              {
                // color: "#50a5f1",
                // border: "1.8px solid #50a5f1",
                // background: "#ffffff",
              }
            }
            className={
              companyId !== "621095ca22dc209646e5381f"
                ? "create-sales-btn"
                : "create-sales-btn disabled-button"
            }
            onClick={() => bookingComplete()}
          >
            <i className="fas fa-book mx-1"></i>
            Booking Complete
          </div>
        </Col>

        {/* Booking Complete Modal */}
        {bookingModal && (
          <Modal show={bookingModal} onHide={handleBookingModal}>
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                minHeight: "65px",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              <div className="d-flex flex-row">
                <span>BOOKING COMPLETE</span>
              </div>
            </Modal.Header>
            <Modal.Body>
              <Col>
                <Row className="d-flex flex-column">
                  <Col xl="12" lg="12" md="12" sm="12" xs="12" className="mt-2">
                    <Label className="employee-label">
                      Booking Remarks <span className="required mx-1">*</span>
                    </Label>
                    <Input
                      type="textarea"
                      name="bookingRemarks"
                      value={bookingData.bookingRemarks}
                      onChange={(e) => handleBooking(e)}
                      placeholder="Enter Booking Remarks Notes"
                      className="employee-crowd-textarea"
                    />
                    {simpleValidator.current.message(
                      "Booking Remarks",
                      bookingData.bookingRemarks,
                      "required"
                    )}
                  </Col>
                  <Col xl="12" lg="12" md="12" sm="12" xs="12" className="mt-2">
                    <Label className="employee-label">
                      Attachment <span className="required mx-1">*</span>
                    </Label>
                    <Input
                      type="file"
                      id="bookingAttachment"
                      name="bookingAttachment"
                      onChange={(e) => handleChangeBookingAttachment(e)}
                      placeholder="Attach the files"
                      multiple
                    />
                    {simpleValidator.current.message(
                      "Booking Attachment",
                      bookingAttachment,
                      "required"
                    )}
                  </Col>
                </Row>
              </Col>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                className="btn btn-danger"
                onClick={() => setBookingModal(false)}
              >
                Cancel
              </Button>
              <Button
                variant="secondary"
                className="btn btn-success"
                onClick={(e) => bookingCompleteSales(e)}
              >
                Submit
              </Button>
            </Modal.Footer>
          </Modal>
        )}

        {/* Table List Data Start */}

        <Table striped bordered responsive>
          <thead>
            <tr style={{ fontSize: "10px" }}>
              <th>S.No</th>
              <th style={{ minWidth: "60px" }}>Actions</th>
              <th style={{ minWidth: "110px" }}>Follow-up No</th>
              <th style={{ minWidth: "110px" }}>Follow-up Date</th>
              <th style={{ minWidth: "150px" }}>Future Follow-up Date</th>
              <th>Time</th>
              <th style={{ minWidth: "110px" }}>Mode</th>
              <th>Reach Status</th>
              <th style={{ minWidth: "140px" }}>Overall Status</th>
              <th>Budget</th>
              <th>Attachment</th>
            </tr>
          </thead>
          <tbody>
            {pageLoading ? (
              <tr key={0}>
                <td colSpan="11">
                  <img
                    src={loadertable}
                    style={{ width: "100%", height: "230px" }}
                  />
                </td>
              </tr>
            ) : followupTable.length > 0 ? (
              followupTable.map((followup) => {
                const futureFollowUpDate = followup.futureFollowupDate != undefined?moment(
                  followup.futureFollowupDate
                ).format("YYYY-MM-DD"):"--"
                return (
                  <tr key={followup.id}>
                    <td>{followup.sNo}</td>
                    <td
                      // className="d-flex flex-row"
                      // style={{ minWidth: "60px" }}
                    >
                      {<Button
                        type="submit"
                        style={{ fontSize: "8px" }}
                        onClick={() => editFollowupDetails(followup)}
                        className={
                          followup.isEditFollowup
                            ? "disabled-button btn btn-success"
                            : "btn btn-success"
                        }
                      >
                        <i className="fas fa-edit icon-btn"></i>
                      </Button>}
                    </td>
                    <td>
                      {followup && followup.followupEditDetails
                        ? followup.followupEditDetails.followupNo
                        : ""}
                    </td>
                    <td>{followup.followupDate}</td>
                    <td>{futureFollowUpDate}</td>
                    <td>{followup.followupTime}</td>
                    <td>{followup.modeName}</td>
                    <td>{followup.clientReachedStatus}</td>
                    <td>{followup.overAllStatus}</td>
                    <td>{followup.budget}</td>
                    <td>
                      <a href={followup.attachment} download>
                        download
                      </a>
                    </td>
                  </tr>
                )
              })
            ) : (
              <tr key={0}>
                <td
                  colSpan="11"
                  style={{
                    textAlign: "center",
                  }}
                >
                  No Record Found
                </td>
              </tr>
            )}
          </tbody>
          {deleteForm && (
            <Modal show={deleteForm} onHide={handleClose}>
              <Modal.Header>Delete Event Details</Modal.Header>
              <Modal.Body>
                Are you sure you want to delete the Event details ?
              </Modal.Body>
              <Modal.Footer>
                <Button
                  variant="secondary"
                  className="btn btn-danger"
                  onClick={handleClose}
                >
                  Close
                </Button>
                <Button
                  variant="primary"
                  className="btn btn-success"
                  onClick={(event) => {
                    handleClose()
                    removeApiFollowupDetails(event)
                  }}
                >
                  Delete
                </Button>
              </Modal.Footer>
            </Modal>
          )}

          {followupHistoryModal && (
            <Modal show={followupHistoryModal} onHide={handleClose}>
              <Modal.Header>Followup History Details</Modal.Header>
              <Modal.Body>
                <Table bordered>
                  <thead>
                    <tr>
                      <th>Followup Date</th>
                      <th>Remark</th>
                      <th>Created By</th>
                    </tr>
                  </thead>
                  <tbody>
                    {followupRemarksHistoryDetailsUpdated &&
                    followupRemarksHistoryDetailsUpdated.length > 0 ? (
                      followupRemarksHistoryDetailsUpdated.map((item) => {
                        return (
                          <>
                            <tr key={item.key}>
                              <td>{item.historyDate}</td>
                              <td>{item.remarks}</td>
                              <td>{item.name}</td>
                            </tr>
                          </>
                        )
                      })
                    ) : (
                      <tr key={0}>
                        <td colSpan={3} className="text-align-center">
                          {"No Data Found"}
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  variant="secondary"
                  className="btn btn-danger"
                  onClick={() => setFollowupHistoryModal(false)}
                >
                  Close
                </Button>
              </Modal.Footer>
            </Modal>
          )}

          {followupHistoryOverallStatusyModal && (
            <Modal
              show={followupHistoryOverallStatusyModal}
              onHide={handleClose}
            >
              <Modal.Header>Overall Status History Details</Modal.Header>
              <Modal.Body>
                <Table bordered>
                  <thead>
                    <tr>
                      <th>Followup Date</th>
                      <th>Overall Status</th>
                      <th>Created By</th>
                    </tr>
                  </thead>

                  <tbody>
                    {overallLeadDetailsUpdated &&
                    overallLeadDetailsUpdated.length > 0 ? (
                      overallLeadDetailsUpdated.map((item) => {
                        return (
                          <>
                            <tr key={item.key}>
                              <td>{item.historyDate}</td>
                              <td>{item.overallStatus}</td>
                              <td>{item.name}</td>
                            </tr>
                          </>
                        )
                      })
                    ) : (
                      <tr key={0}>
                        <td colSpan={3} className="text-align-center">
                          {"No Data Found"}
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  variant="secondary"
                  className="btn btn-danger"
                  onClick={() => setFollowupHistoryOverallStatusyModal(false)}
                >
                  Close
                </Button>
              </Modal.Footer>
            </Modal>
          )}

          {followupSlotModal && (
            <Modal show={followupSlotModal} onHide={handleClose}>
              <Modal.Header>Time Slot Details</Modal.Header>
              <Modal.Body>
                <Table bordered>
                  <thead>
                    <tr>
                      <th>SL.No</th>
                      <th>Session</th>
                      <th>Count</th>
                    </tr>
                  </thead>

                  <tbody>
                    {timeslotDetailsUpdated &&
                    timeslotDetailsUpdated.length > 0 ? (
                      timeslotDetailsUpdated.map((item) => {
                        return (
                          <>
                            <tr key={item.key}>
                              <td>{item.historyDate}</td>
                              <td>{item.overallStatus}</td>
                              <td>{item.name}</td>
                            </tr>
                          </>
                        )
                      })
                    ) : (
                      <tr key={0}>
                        <td colSpan={3} className="text-align-center">
                          {"No Data Found"}
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  variant="secondary"
                  className="btn btn-danger"
                  onClick={() => setFollowupSlotModal(false)}
                >
                  Close
                </Button>
              </Modal.Footer>
            </Modal>
          )}
        </Table>

        {/* Table List Data End */}

        {/* Follow-up Start */}

        <Col>
          {followupModal && (
            <form className="event-details-form-content">
              {/* Current Follow-up */}

              <p
                style={{
                  color: "#4486eb",
                  margin: "0px",
                  marginRight: "15px",
                  fontSize: "16px",
                  fontWeight: "500",
                }}
              >
                Current Follow-up
                <span className="tooltip-heading">
                  <i
                    className="fa fa-info-circle"
                    aria-hidden="true"
                    id="currentFollowupTooltip"
                  ></i>
                  <UncontrolledTooltip
                    placement="right"
                    target="currentFollowupTooltip"
                  >
                    Current Follow-up Discription
                  </UncontrolledTooltip>
                </span>
              </p>

              <Row>
                <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                  <div className="d-flex justify-content-between">
                    <Label className="event-label">
                      Follow-Up Date
                      <span className="event-required">*</span>
                    </Label>
                  </div>
                  <Input
                    type="date"
                    name="cFDate"
                    value={currentFollowUp.cFDate}
                    disabled={true}
                    onChange={(e) =>
                      handleChange(e, clientDetails.currentFollowUp)
                    }
                    placeholder="Select Date"
                  />
                  {simpleValidator.current.message(
                    "Follow-Up Date",
                    currentFollowUp.cFDate,
                    "required"
                  )}
                </Col>

                <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                  <Label className="event-label">
                    Time
                    <span className="event-required">*</span>
                  </Label>
                  <Input
                    type="time"
                    name="cFTime"
                    disabled={true}
                    value={currentFollowUp.cFTime}
                    onChange={(e) =>
                      handleChange(e, clientDetails.currentFollowUp)
                    }
                    placeholder="Enter Follow-Up Time"
                    className="disabled-button"
                  />
                  {simpleValidator.current.message(
                    "Follow-Up Time",
                    currentFollowUp.cFDate,
                    "required"
                  )}
                </Col>

                <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                  <Label className="event-label">
                    Follow-Up Mode
                    <span className="event-required">*</span>
                  </Label>
                  <Select
                    name="cFMode"
                    value={cFMode}
                    options={
                      followupRecordsMetaData.followupModeOptions
                        ? followupRecordsMetaData.followupModeOptions
                        : []
                    }
                    onChange={(e) => handleChangeSelectBox(e, "cFMode")}
                  />
                  {simpleValidator.current.message(
                    "Follow-Up Mode",
                    currentFollowUp.cFMode,
                    "required"
                  )}
                </Col>

                <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                  <div className="d-flex justify-content-between">
                    <Label className="event-label">
                      Budget
                      <span className="event-required">*</span>
                    </Label>
                  </div>
                  <Input
                    type="text"
                    name="cFBudget"
                    value={currentFollowUp.cFBudget}
                    // options={venueOptions}
                    onChange={(e) => {
                      const re = /^[0-9\b/+]+$/
                      if (e.target.value === "" || re.test(e.target.value)) {
                        handleChange(e, clientDetails.currentFollowUp)
                      }
                    }}
                    disabled={
                      isEdit === true
                        ? false
                        : budgetFromQuotation > 0
                        ? true
                        : false
                    }
                    // onChange={setVenueName}
                    placeholder="Enter Budget"
                    className="client-number-field"
                  />
                  {simpleValidator.current.message(
                    "Budget",
                    currentFollowUp.cFBudget,
                    "required"
                  )}
                </Col>
              </Row>

              <Row>
                <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                  <div className="d-flex justify-content-between">
                    <Label className="event-label">
                      Client Profile
                      <span className="event-required">*</span>
                    </Label>
                  </div>
                  <Select
                    name="cFClientProfile"
                    options={
                      recordsMetaData.clientProfileOptions
                        ? recordsMetaData.clientProfileOptions
                        : []
                    }
                    onChange={(e) =>
                      handleChangeSelectBox(e, "cFClientProfile")
                    }
                    value={cFClientProfile}
                  />
                  {simpleValidator.current.message(
                    "Client Profile",
                    cFClientProfile,
                    "required"
                  )}
                </Col>

                <Col lg="4" md="4" sm="12" xs="12" className="mt-3">
                  <div className="d-flex justify-content-between">
                    <Label className="event-label">
                      Client Profile Remarks
                      <span className="event-required">*</span>
                    </Label>
                  </div>
                  <Input
                    type="text"
                    name="cFClientProfileRemarks"
                    value={currentFollowUp.cFClientProfileRemarks}
                    // options={venueOptions}
                    onChange={(e) =>
                      handleChange(e, clientDetails.currentFollowUp)
                    }
                    // onChange={setVenueName}
                    placeholder="Enter Client Profile Remarks"
                  />
                  {simpleValidator.current.message(
                    "Client Profile Remarks",
                    currentFollowUp.cFClientProfileRemarks,
                    "required"
                  )}
                </Col>

                <Col lg="2" md="2" sm="12" xs="12" className="mt-3">
                  <div className="d-flex justify-content-between vip-checkbox-div">
                    <Label className="event-label"></Label>
                  </div>
                  <div
                    onChange={(e) =>
                      handleChange(e, clientDetails.currentFollowUp)
                    }
                  >
                    <Input
                      type="checkbox"
                      className="form-check-input"
                      name="cFVip"
                      value="VIP"
                      checked={currentFollowUp.cFVip === "VIP"}
                    />
                    <Label className="event-label vip-checkbox-label">
                      {" "}
                      VIP{" "}
                    </Label>

                    <Input
                      type="checkbox"
                      className="form-check-input"
                      name="cFVip"
                      value="VVIP"
                      checked={currentFollowUp.cFVip === "VVIP"}
                    />
                    <Label className="event-label vip-checkbox-label">
                      {" "}
                      VVIP{" "}
                    </Label>
                  </div>
                  {/* {simpleValidator.current.message(
                    "Client Status",
                    currentFollowUp.cFVip,
                    "required"
                  )} */}
                </Col>
                <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                  <div className="d-flex justify-content-between">
                    <Label className="event-label">
                      Client Status Remarks
                      <span className="event-required">*</span>
                    </Label>
                  </div>
                  <Input
                    type="textarea"
                    name="clientStatusRemark"
                    value={currentFollowUp.clientStatusRemark}
                    // options={venueOptions}
                    onChange={(e) =>
                      handleChange(e, clientDetails.currentFollowUp)
                    }
                    // onChange={setVenueName}
                    placeholder="Enter Client Status Remarks"
                  />
                  {simpleValidator.current.message(
                    "Client Status Remarks",
                    currentFollowUp.clientStatusRemark,
                    "required"
                  )}
                </Col>
              </Row>

              <Row>
                <Col lg="3" md="3" sm="12" xs="12" className="">
                  <div className="d-flex justify-content-between vip-checkbox-div">
                    <Label className="event-label">
                      Reach Status
                      <span className="event-required">*</span>
                    </Label>
                  </div>
                  <div
                    onChange={(e) =>
                      handleChange(e, clientDetails.currentFollowUp)
                    }
                  >
                    <Input
                      type="radio"
                      className="form-check-input"
                      name="cFReachedStatus"
                      value="Connected"
                      checked={currentFollowUp.cFReachedStatus === "Connected"}
                    />
                    <Label className="event-label status-checkbox-label">
                      {" "}
                      Connected{" "}
                    </Label>

                    <Input
                      type="radio"
                      className="form-check-input"
                      name="cFReachedStatus"
                      value="Not Connected"
                      checked={
                        currentFollowUp.cFReachedStatus === "Not Connected"
                      }
                    />
                    <Label className="event-label status-checkbox-label">
                      {" "}
                      Not Connected{" "}
                    </Label>
                  </div>
                  {simpleValidator.current.message(
                    "Reach Status",
                    currentFollowUp.cFReachedStatus,
                    "required"
                  )}
                </Col>

                <Col lg="6" md="6" sm="12" xs="12" className="mt-3">
                  <div className="d-flex justify-content-between">
                    <Label className="event-label">
                      Follow-Up Remarks
                      <span className="event-required">*</span>
                      <span
                        className="followup-sub-link pointer"
                        onClick={() => followupHistoryFollowUpRemark()}
                      >
                        History
                      </span>
                    </Label>
                  </div>
                  <Input
                    type="text"
                    name="cFRemark"
                    value={currentFollowUp.cFRemark}
                    // options={venueOptions}
                    onChange={(e) =>
                      handleChange(e, clientDetails.currentFollowUp)
                    }
                    // onChange={setVenueName}
                    placeholder="Enter Follow-Up Remarks"
                  />
                  {simpleValidator.current.message(
                    "Follow-Up Remarks",
                    currentFollowUp.cFRemark,
                    "required"
                  )}
                </Col>

                <Col xl="3" lg="3" md="3" sm="6" xs="6" className="mt-3">
                  <div className="d-flex justify-content-between">
                    <Label className="event-label">
                      Attachment
                      <span className="event-required">*</span>
                    </Label>
                  </div>

                  <div className="btn header-item noti-icon">
                    <img
                      alt="Desktop Attachment"
                      style={{ height: "35px", width: "45px" }}
                      className="attachmentImage pointer"
                      src={attachmentDesktop}
                      onClick={() => handleClickAttachment("desktop")}
                    />
                    <span
                      className="badge bg-danger rounded-pill"
                      style={{ fontSize: "8px", top: "0px" }}
                    >
                      {destopAttachment.length}
                    </span>
                  </div>

                  <input
                    type="file"
                    id="attachmentDestop"
                    name="attachmentDestop"
                    onChange={(e) =>
                      handleChangeDesktopAttachment(e, renderPage)
                    }
                    ref={inputDesktopAttachmentFile}
                    style={{ display: "none" }}
                    multiple
                  />

                  <div className="btn header-item noti-icon">
                    <img
                      alt="Mobile Attachment"
                      style={{ height: "35px", width: "45px" }}
                      className="attachmentImage pointer"
                      src={attachmentMobile}
                      onClick={() => handleClickAttachment("mobile")}
                    />
                    <span
                      className="badge bg-danger rounded-pill"
                      style={{ fontSize: "8px", top: "0px" }}
                    >
                      {mobileAttachmentSelected.length}
                    </span>
                  </div>

                  {attachmentValidation == true &&
                  (destopAttachment.length == 0 ||
                    mobileAttachmentSelected.length == 0 ) ? (
                    <div className="srv-validation-message">
                      The Attachment field is required.
                    </div>
                  ) : (
                    ""
                  )}
                  {attachmentValueArrayUpdated &&
                  attachmentValueArrayUpdated.length > 0 ? (
                    <Col lg="12">
                      <span
                        className="followup-sub-link pointer"
                        onClick={() => {
                          setViewAttachmentModal(true)
                        }}
                      >
                        {" "}
                        View {
                          attachmentValueArrayUpdated.length
                        } Attachments{" "}
                      </span>
                   
                    </Col>
                  ) : (
                    ""
                  )}
                </Col>

                <Col lg="3" md="3" sm="12" xs="12" className="">
                  <Label className="event-label">
                    Follow-Up Status
                    <span className="event-required">*</span>
                  </Label>
                  <Select
                    name="cFStatus"
                    value={cFStatus}
                    options={
                      followupRecordsMetaData.followupActionOptions
                        ? followupRecordsMetaData.followupActionOptions
                        : []
                    }
                    onChange={(e) => handleChangeSelectBox(e, "cFStatus")}
                  />
                  {simpleValidator.current.message(
                    "Follow-Up Status ",
                    currentFollowUp.cFStatus,
                    "required"
                  )}
                </Col>

                <Col lg="6" md="6" sm="12" xs="12" className="">
                  <div className="d-flex justify-content-between">
                    <Label className="event-label">
                      Overall Status
                      <span className="event-required">*</span>
                      <span
                        className="followup-sub-link pointer"
                        onClick={() => followupHistoryOverallStatus()}
                      >
                        History
                      </span>
                    </Label>
                  </div>
                  <Input
                    type="text"
                    name="cFOverAllStatus"
                    value={currentFollowUp.cFOverAllStatus}
                    // options={venueOptions}
                    onChange={(e) =>
                      handleChange(e, clientDetails.currentFollowUp)
                    }
                    // onChange={setVenueName}
                    placeholder="Enter Overall Status"
                  />
                  {simpleValidator.current.message(
                    "Over all Status",
                    currentFollowUp.cFOverAllStatus,
                    "required"
                  )}
                </Col>
                <Col lg="3" md="3" sm="12" xs="12" className="">
                  <Label className="event-label">
                    Lead Sub Status
                    <span className="event-required">*</span>
                  </Label>
                  <Select
                    name="cFLeadSubStatus"
                    value={cFLeadSubStatus}
                    onChange={(e) =>
                      handleChangeSelectBox(e, "cFLeadSubStatus")
                    }
                    options={subStatusOptions}
                    placeholder="Select"
                  />
                  {simpleValidator.current.message(
                    "LeadSubStatus",
                    currentFollowUp.cFLeadSubStatus,
                    "required"
                  )}
                </Col>
              </Row>

              {/* Current Follow-up */}

              <p
                style={{
                  color: "#4486eb",
                  margin: "0px",
                  marginRight: "15px",
                  marginTop: "15px",
                  fontSize: "16px",
                  fontWeight: "500",
                }}
              >
                Future Follow-up
                <span className="tooltip-heading">
                  <i
                    className="fa fa-info-circle"
                    aria-hidden="true"
                    id="futureFollowupTooltip"
                  ></i>
                  <UncontrolledTooltip
                    placement="right"
                    target="futureFollowupTooltip"
                  >
                    Future Follow-up Discription
                  </UncontrolledTooltip>
                </span>
              </p>

              <Row>
                <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                  <div className="d-flex justify-content-between">
                    <Label className="event-label">
                      Follow-Up Date
                      <span className="event-required">*</span>
                      <span
                        className="followup-sub-link pointer"
                        onClick={() => followupSlot()}
                      >
                        Slot
                      </span>
                    </Label>
                  </div>
                  <Input
                    type="datetime-local"
                    name="fFdate"
                    value={futureFollowUp.fFdate}
                    // disabled={fFMode.label === "OFFICE VISIT" ? true : false}
                    onChange={(e) =>
                      handleChange(e, clientDetails.futureFollowUp)
                    }
                    placeholder="Select Follow-Up Date"
                  />
                  {simpleValidator.current.message(
                    "Follow-Up Date",
                    futureFollowUp.fFdate,
                    "required"
                  )}
                </Col>

                <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                  <Label className="event-label">
                    Follow-Up Mode
                    <span className="event-required">*</span>
                  </Label>
                  <Select
                    name="fFMode"
                    value={fFMode}
                    options={
                      followupRecordsMetaData.followupModeOptions
                        ? followupRecordsMetaData.followupModeOptions
                        : []
                    }
                    onChange={(e) => handleChangeSelectBox(e, "fFMode")}
                  />
                  {simpleValidator.current.message(
                    "Follow-Up Mode ",
                    futureFollowUp.fFMode,
                    "required"
                  )}
                </Col>

                <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                  <Label className="event-label">Client Visit</Label>
                  <Select
                    name="fFClientVisit"
                    value={fFClientVisit}
                    options={clientVisit}
                    onChange={(e) => handleChangeSelectBox(e, "fFClientVisit")}
                    isDisabled={fFMode.label === "OFFICE VISIT" ? false : true}
                  />
                </Col>

                <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                  <div className="d-flex justify-content-between">
                    <Label className="event-label">
                      {" Visit Date & Time "}
                      <span className="event-required">*</span>
                    </Label>
                  </div>
                  <Input
                    type="datetime-local"
                    name="fFVisitDateTime"
                    onChange={(e) =>
                      handleChange(e, clientDetails.futureFollowUp)
                    }
                    placeholder="Select Date"
                    value={futureFollowUp.fFVisitDateTime}
                    disabled={fFMode.label === "OFFICE VISIT" ? false : true}
                  />
                  {simpleValidator.current.message(
                    "Visit Date & Time",
                    futureFollowUp.fFVisitDateTime,
                    "required"
                  )}
                </Col>
              </Row>

              <Row>
                <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                  <div className="d-flex justify-content-between">
                    <Label className="event-label">
                      Session
                      <span className="event-required">*</span>
                    </Label>
                  </div>
                  <Input
                    type="text"
                    name="fFSession"
                    value={futureFollowUp.fFSession}
                    // onChange={(e) =>
                    //   handleChange(e, clientDetails.futureFollowUp)
                    // }
                    placeholder="Enter Session"
                  />
                  {simpleValidator.current.message(
                    "Session",
                    futureFollowUp.fFSession,
                    "required"
                  )}
                </Col>

                <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                  <Label className="event-label">
                    Follow-up Strategy
                    <span className="event-required">*</span>
                  </Label>
                  <Select
                    name="fFStrategy"
                    value={fFStrategy}
                    options={
                      followupRecordsMetaData.followupStrategyOptions
                        ? followupRecordsMetaData.followupStrategyOptions
                        : []
                    }
                    onChange={(e) => handleChangeSelectBox(e, "fFStrategy")}
                  />
                  {simpleValidator.current.message(
                    "Follow-up Strategy",
                    futureFollowUp.fFStrategy,
                    "required"
                  )}
                </Col>

                <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                  <div className="d-flex justify-content-between">
                    <Label className="event-label">
                      Strategy Remark
                      <span className="event-required">*</span>
                    </Label>
                  </div>
                  <Input
                    type="text"
                    name="fFStrategyRemark"
                    value={futureFollowUp.fFStrategyRemark}
                    onChange={(e) =>
                      handleChange(e, clientDetails.futureFollowUp)
                    }
                    placeholder="Enter Strategy Remark"
                  />
                  {simpleValidator.current.message(
                    "Strategy Remark",
                    futureFollowUp.fFStrategyRemark,
                    "required"
                  )}
                </Col>
                <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                  <Label className="event-label">
                    Followup Sales Urge
                    <span className="event-required">*</span>
                  </Label>
                  <Select
                    name="fFSalesUrge"
                    value={fFSalesUrge}
                    options={salesUrgeOptions}
                    onChange={(e) => handleChangeSelectBox(e, "fFSalesUrge")}
                  />
                  {simpleValidator.current.message(
                    "Future Followup Saleurge",
                    futureFollowUp.fFSalesUrge,
                    "required"
                  )}
                </Col>
              </Row>

              {/* Cross Promotion */}

              <p
                style={{
                  color: "#4486eb",
                  margin: "0px",
                  marginRight: "15px",
                  marginTop: "15px",
                  fontSize: "16px",
                  fontWeight: "500",
                }}
              >
                Cross Promotion
                <span className="tooltip-heading">
                  <i
                    className="fa fa-info-circle"
                    aria-hidden="true"
                    id="crossPromotionTooltip"
                  ></i>
                  <UncontrolledTooltip
                    placement="right"
                    target="crossPromotionTooltip"
                  >
                    Cross Promotion Description
                  </UncontrolledTooltip>
                </span>
              </p>
              <div
                style={{
                  // height: isEdit == true ? "100px" : "300px",
                  // overflowY: isEdit == true ? "none" : "scroll",
                  height: "400px",
                  overflowY:  "scroll",
                }}
              >
                <Table bordered>
                  <thead>
                    <tr>
                      <th>Company Name</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {crossPromotion ? (
                      crossPromotion.map((item, i) => {
                        return (
                          <>
                            <tr key={i}>
                              <td>{item.companyName}</td>
                              <td>
                                <Col md="12">
                                  <div
                                    onChange={(e) =>
                                      handleChangeCrossOver(e, item.id)
                                    }
                                  >
                                    <Input
                                      type="radio"
                                      className="form-check-input"
                                      name={item.id}
                                      value={"yes"}
                                      checked={item.action === true}
                                      onClick={() => setRenderPage(!renderPage)}
                                    />
                                    <Label className="event-label vip-checkbox-label">
                                      {" "}
                                      Yes{" "}
                                    </Label>

                                    <Input
                                      type="radio"
                                      className="form-check-input"
                                      name={item.id}
                                      value={"no"}
                                      checked={item.action === false}
                                      onClick={() => setRenderPage(!renderPage)}
                                    />
                                    <Label className="event-label vip-checkbox-label">
                                      {" "}
                                      No{" "}
                                    </Label>
                                  </div>
                                </Col>
                              </td>
                            </tr>
                          </>
                        )
                      })
                    ) : (
                      <tr key={0}>
                        <td
                          colSpan={2}
                          style={{
                            textAlign: "center",
                          }}
                        >
                          No records found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </div>

              {/* Special Instructions */}
              {!isEmpty(leadDetails) &&
              leadDetails &&
              leadDetails[0].leadType == "wedding" ? (
                <Row>
                  <Col lg="9" md="9" sm="12">
                    <p
                      style={{
                        color: "#4486eb",
                        margin: "0px",
                        marginRight: "15px",
                        marginTop: "15px",
                        fontSize: "16px",
                        fontWeight: "500",
                      }}
                    >
                      Special Instructions
                      <span className="tooltip-heading">
                        <i
                          className="fa fa-info-circle"
                          aria-hidden="true"
                          id="specialInstructionsTooltip"
                        ></i>
                        <UncontrolledTooltip
                          placement="right"
                          target="specialInstructionsTooltip"
                        >
                          Special Instructions Discription
                        </UncontrolledTooltip>
                      </span>
                    </p>
                  </Col>
                  <Col lg="3" md="3" sm="12">
                    <button
                      onClick={addSpecialInstruction}
                      type="button"
                      className={
                        isEdit
                          ? "add-more-button disabled-button"
                          : "add-more-button"
                      }
                      disabled={isEdit}
                    >
                      Add More
                    </button>
                  </Col>
                </Row>
              ) : (
                ""
              )}
              {!isEmpty(leadDetails) &&
              leadDetails &&
              leadDetails[0].leadType == "wedding" ? (
                <Col
                  className="mt-3"
                  style={{ paddingBottom: "40px", paddingTop: "40px" }}
                >
                  <Table bordered>
                    <thead>
                      <tr>
                        <th>Department</th>
                        <th>Team</th>
                        <th>Special Instructions</th>
                        <th className="icon-section">#</th>
                      </tr>
                    </thead>
                    <tbody>
                      {specialInstruction.map((item, index) => {
                        return (
                          <>
                            <tr className="bg-white" key={index}>
                              <td>
                                <Select
                                  name="department"
                                  placeholder="Select Department"
                                  value={
                                    item.departmentId
                                      ? {
                                          value: item.departmentId,
                                          label: item.departmentName,
                                        }
                                      : ""
                                  }
                                  options={followupDepartmentDetails}
                                  onChange={(e) =>
                                    changeSpecialInstruction(
                                      e,
                                      index,
                                      "departmentId"
                                    )
                                  }
                                />
                              </td>
                              <td>
                                <Select
                                  name="team"
                                  placeholder="Select Team"
                                  value={
                                    item.teamId
                                      ? {
                                          value: item.teamId,
                                          label: item.teamName,
                                        }
                                      : ""
                                  }
                                  options={followupTeamDetails}
                                  onChange={(e) =>
                                    changeSpecialInstruction(e, index, "teamId")
                                  }
                                />
                              </td>
                              <td>
                                <Input
                                  name="testContent"
                                  placeholder="Test Special Instructions Content"
                                  value={item.remarks}
                                  onChange={(e) =>
                                    changeSpecialInstruction(
                                      e,
                                      index,
                                      "remarks"
                                    )
                                  }
                                />
                              </td>
                              <td>
                                <i
                                  className="fa fa-times remove-icon"
                                  onClick={() =>
                                    removeSpecialInstruction(index)
                                  }
                                ></i>
                              </td>
                            </tr>
                          </>
                        )
                      })}

                      {leadCarryForwardListSpecialInstruction &&
                        leadCarryForwardListSpecialInstruction.length > 0 &&
                        leadCarryForwardListSpecialInstruction.map((item) => {
                          return (
                            <>
                              <tr className="bg-white">
                                <td>{item.departmentName}</td>
                                <td>{item.teamName}</td>
                                <td>{item.remarks}</td>
                                <td>{item.mode}</td>
                              </tr>
                            </>
                          )
                        })}
                    </tbody>
                  </Table>
                </Col>
              ) : (
                ""
              )}

              {/* Special Instructions */}
              {!isEmpty(leadDetails) &&
              leadDetails &&
              leadDetails[0].leadType == "wedding" ? (
                <Row>
                  <Col lg="9" md="9" sm="12">
                    <p
                      style={{
                        color: "#4486eb",
                        margin: "0px",
                        marginRight: "15px",
                        marginTop: "15px",
                        fontSize: "16px",
                        fontWeight: "500",
                      }}
                    >
                      Photography Event Check List
                      <span className="tooltip-heading">
                        <i
                          className="fa fa-info-circle"
                          aria-hidden="true"
                          id="photographyEventCheckListTooltip"
                        ></i>
                        <UncontrolledTooltip
                          placement="right"
                          target="photographyEventCheckListTooltip"
                        >
                          Photography Event Check List Discription
                        </UncontrolledTooltip>
                      </span>
                    </p>
                  </Col>
                  <Col lg="3" md="3" sm="12">
                    <button
                      onClick={addPhotography}
                      type="button"
                      className={
                        isEdit
                          ? "add-more-button disabled-button"
                          : "add-more-button"
                      }
                      disabled={isEdit}
                    >
                      Add More
                    </button>
                  </Col>
                </Row>
              ) : (
                ""
              )}
              {!isEmpty(leadDetails) &&
              leadDetails &&
              leadDetails[0].leadType == "wedding" ? (
                <Col
                  className="mt-3"
                  style={{ paddingBottom: "40px", paddingTop: "40px" }}
                >
                  <Table bordered responsive>
                    <thead>
                      <tr>
                        <th> Photography Event Check List Details</th>
                        <th className="icon-section">#</th>
                      </tr>
                    </thead>
                    <tbody>
                      {photographyEventCheckList.map((item, index) => {
                        return (
                          <>
                            <tr>
                              <td>
                                <Input
                                  name="photography"
                                  value={item.description}
                                  onChange={(e) => changePhotography(e, index)}
                                  placeholder="Photography Event Check List details"
                                />
                              </td>
                              <td>
                                <i
                                  className="fa fa-times remove-icon"
                                  onClick={() => removePhotography(index)}
                                ></i>
                              </td>
                            </tr>
                          </>
                        )
                      })}

                      {leadCarryForwardListCheckList &&
                        leadCarryForwardListCheckList.length > 0 &&
                        leadCarryForwardListCheckList.map((item) => {
                          if (item.description) {
                            return (
                              <>
                                <tr>
                                  <td>{item.description}</td>
                                  <td>{item.mode}</td>
                                </tr>
                              </>
                            )
                          }
                        })}
                    </tbody>
                  </Table>
                </Col>
              ) : (
                ""
              )}

              <Col md="12" xl="12" lg="12" className="event-details-submit">
                {isEdit ? (
                  <>
                    <button
                      onClick={() => {
                        // setOpenModal(!openModal)
                        handleCancel()
                      }}
                      type="button"
                      className="btn btn-danger btn-label form-cancel-btn"
                    >
                      <i className="bx bx-block label-icon "></i>
                      Cancel
                    </button>
                    <button
                      type="submit"
                      onClick={(e) => {
                        handleUpdate(e)
                      }}
                      className="btn btn-success btn-label form-submit-btn"
                    >
                      <i className="bx bx-check-double label-icon"></i>
                      Update
                    </button>
                  </>
                ) : (
                  <>
                    {" "}
                    <button
                      onClick={() => {
                        handleCancel()
                      }}
                      type="button"
                      className="btn btn-danger btn-label form-cancel-btn"
                    >
                      <i className="bx bx-block label-icon "></i>
                      Cancel
                    </button>
                    <button
                      type="submit"
                      onClick={(e) => {
                        handleSubmit(e)
                      }}
                      className="btn btn-success btn-label form-submit-btn"
                    >
                      <i className="bx bx-check-double label-icon"></i>
                      Submit
                    </button>
                  </>
                )}
              </Col>
            </form>
          )}
        </Col>
        <p></p>

        {/* Follow-up End */}

        {/* Attachment File Modal*/}

        {mobileAttachmentForm && (
          <Modal show={mobileAttachmentForm} onHide={handleClose} size="lg">
            <Modal.Header>
              <h4>Mobile Attachment Details</h4>
            </Modal.Header>
            <Modal.Body>
              <Row>
                <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                  <div className="d-flex justify-content-between">
                    <Label className="event-label">Search</Label>
                  </div>
                  <Input
                    type="date"
                    name="mobileAttachment"
                    placeholder="Select Date"
                  />
                  <br />
                  <br />
                </Col>

                <Col lg="12" md="12" sm="12" xs="12">
                  <Table bordered>
                    <thead>
                      <tr>
                        <th>Sl.No</th>
                        <th>Date &#38; Time</th>
                        <th>Customer Name</th>
                        <th>Description</th>
                        <th>Attachment</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {attachmentRecordUpdated &&
                      attachmentRecordUpdated.length > 0 ? (
                        attachmentRecordUpdated.map((item) => {
                          return (
                            <>
                              <tr key={item.key}>
                                <td>{item.key + 1}</td>
                                <td>{item.pickDateTime}</td>
                                <td>{item.customerDetails}</td>
                                <td>{item.description}</td>
                                <td>
                                  {item.attachmentType == "image" ? (
                                    <object
                                      data={item.attachment}
                                      type="image/png"
                                      width="120"
                                      height="90"
                                    >
                                      <img
                                        src={imageNotFound}
                                        width="120"
                                        height="90"
                                      />
                                    </object>
                                  ) : (
                                    ""
                                  )}
                                  {item.attachmentType == "audio" ? (
                                    <audio controls>
                                      <source
                                        src={item.attachment}
                                        type="audio/mpeg"
                                      />
                                      Your browser does not support the audio
                                      element.
                                    </audio>
                                  ) : (
                                    ""
                                  )}
                                  <br />
                                  <br />
                                  <a href={item.attachment} download>
                                    download
                                  </a>
                                </td>
                                <td>
                                  <div>
                                    <Input
                                      type="checkbox"
                                      className="form-check-input checkbox-attachment"
                                      name="checkbox"
                                      onChange={(e) =>
                                        handleChangeAttachmentCheckbox(
                                          e,
                                          item.id,
                                          item.attachment
                                        )
                                      }
                                    />
                                  </div>
                                </td>
                              </tr>
                            </>
                          )
                        })
                      ) : (
                        <tr key={0}>
                          <td colSpan={5} className="text-align-center">
                            {"No Data Found"}
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </Col>
              </Row>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                className="btn btn-danger"
                onClick={handleCloseAttachment}
              >
                Close
              </Button>
              <Button
                variant="primary"
                className="btn btn-success"
                onClick={(event) => {
                  handleSubmitAttachment(event)
                }}
              >
                Upload
              </Button>
            </Modal.Footer>
          </Modal>
        )}

        {viewAttachmentModal && (
          <Modal show={viewAttachmentModal}>
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                minHeight: "65px",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              <div className="d-flex flex-row">
                <span> View Attachments </span>
              </div>
            </Modal.Header>
            <Modal.Body>
              <Col>
                <Table bordered>
                  <thead>
                    <tr>
                      <th>Sl.No</th>
                      <th>Attachment</th>
                    </tr>
                  </thead>
                  <tbody>
                    {attachmentValueArrayUpdated &&
                    attachmentValueArrayUpdated.length > 0 ? (
                      attachmentValueArrayUpdated.map((item, index) => {
                        return (
                          <>
                            <tr key={index}>
                              <td>{index + 1}</td>
                              <td>
                                {item.attachmentType == "image" ? (
                                  <object
                                    data={item.file}
                                    type="image/png"
                                    width="100"
                                    height="70"
                                  >
                                    <img
                                      src={imageNotFound}
                                      width="100"
                                      height="70"
                                    />
                                  </object>
                                ) : (
                                  ""
                                )}

                                {item.attachmentType == "audio" ? (
                                  <audio controls>
                                    <source src={item.file} type="audio/mpeg" />
                                    Your browser does not support the audio
                                    element.
                                  </audio>
                                ) : (
                                  ""
                                )}
                                <br />
                                <br />
                                <a href={item.file} download>
                                  download
                                </a>
                              </td>
                            </tr>
                          </>
                        )
                      })
                    ) : (
                      <tr key={0}>
                        <td colSpan={3} className="text-align-center">
                          {"No Data Found"}
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </Col>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                className="btn btn-danger"
                onClick={() => setViewAttachmentModal(false)}
              >
                Close
              </Button>
            </Modal.Footer>
          </Modal>
        )}

        {rejectModal && (
          <Modal show={rejectModal}>
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                minHeight: "65px",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              <div className="d-flex flex-row">
                <span>Are you sure you want to reject the lead?</span>
              </div>
            </Modal.Header>
            <Modal.Body>
              <Col>
                <Row className="d-flex flex-column">
                  <Col xl="12" lg="12" md="12" sm="12" xs="12" className="mt-2">
                    <Label className="employee-label">
                      Reject Status <span className="required mx-1">*</span>
                    </Label>
                    <Select
                      name="rejectStatus"
                      value={rejectStatus}
                      onChange={(e) => setRejectStatus(e)}
                      placeholder="Select Status"
                      options={
                        !isEmpty(rejectReasonOptions) ? rejectReasonOptions : []
                      }
                    />
                    {simpleValidator.current.message(
                      "rejectStatus",
                      rejectStatus,
                      "required"
                    )}
                  </Col>
                  <Col xl="12" lg="12" md="12" sm="12" xs="12" className="mt-2">
                    <Label className="employee-label">
                      Reject Remarks <span className="required mx-1">*</span>
                    </Label>
                    <Input
                      type="textarea"
                      name="rejectRemarks"
                      value={rejectData.rejectRemarks}
                      onChange={(e) => handleReject(e)}
                      placeholder="Enter Reject Remarks Notes"
                      className="employee-crowd-textarea"
                    />
                    {simpleValidator.current.message(
                      "rejectRemarks",
                      rejectData.rejectRemarks,
                      "required"
                    )}
                  </Col>
                  <Col xl="12" lg="12" md="12" sm="12" xs="12" className="mt-2">
                    <Label className="employee-label">
                      Attachment<span className="required mx-1">*</span>
                    </Label>
                    <Input
                      type="file"
                      id="reject"
                      // value={rejectAttachment}
                      name="rejectAttachment"
                      onChange={(e) => handleChangeRejectAttachment(e)}
                      placeholder="Attach the files"
                      multiple
                    />
                    {simpleValidator.current.message(
                      "rejectAttachment",
                      rejectAttachment,
                      "required"
                    )}
                  </Col>
                </Row>
              </Col>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                className="btn btn-danger"
                onClick={() => setRejectModal(false)}
              >
                Cancel
              </Button>
              <Button
                variant="secondary"
                className="btn btn-success"
                onClick={(e) => rejectLead(e)}
              >
                Submit
              </Button>
            </Modal.Footer>
          </Modal>
        )}
      </Row>
    </React.Fragment>
  )
}

FollowUpDetails.propTypes = {
  dispatch: PropTypes.func,
  record_event_details: PropTypes.array,
  recordsMetaData: PropTypes.object,
  clientId: PropTypes.any,
  recordClientProfile: PropTypes.object,
  leadDetails: PropTypes.array,
  records: PropTypes.array,
  error: PropTypes.any,
  access: PropTypes.array,
  metaData: PropTypes.object,
  loading: PropTypes.any,
  location: PropTypes.array,
  success: PropTypes.any,
}
const mapStateToProps = (state) => ({
  eventProps: state.Event.record_event_details,
})

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  }
}
export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
    // loadRecordClientDetails,
    // createRecord,
    // deleteRecord,
    // updateRecord,
  )(FollowUpDetails)
)
